<template>
    <modal :show.sync=show modalClasses="large-sized-modal modal-hide-footer" headerClasses="pb-0" bodyClasses="p-3">
        <h3 slot="header" class="mb-0 font-weight-500">Total Cases</h3>

        <div v-if="tableData.length > 0" class="card-table rounded-bottom">
            <el-table
            :data="tableData"
            show-index
            show-summary
            :summary-method="casesSummaries"
            style="width: 100%">
                <el-table-column
                    type="index"
                    label="#"
                    width="50"
                ></el-table-column>

                <el-table-column
                        prop="comms_payout_summary_id"
                        label="Comms Payout Summary ID"
                        min-width="100"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <a href="#" @click.prevent="openView(scope.row)">
                                #<span class="name text-primary">{{ scope.row.comms_payout_summary_id }}</span>
                            </a>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cps_develop_nett_price"
                        label="Pre Sales (RM)"
                        min-width="130"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cps_develop_nett_price | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cps_actual_develop_nett_price"
                        label="Actual Sales (RM)"
                        min-width="130"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cps_actual_develop_nett_price | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cps_service_type_percentage"
                        label="Comm.(%)"
                        min-width="130"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <span class="name text-primary">{{ scope.row.cps_service_type_percentage }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cps_total_revenue_point"
                        label="Pre Rev.(RM)"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.cps_total_revenue_point | moneyFormatter }}
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="cps_actual_total_revenue_point"
                        label="Actual Rev.(RM)"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <div style="background-color: lightblue;">
                                {{ scope.row.cps_actual_total_revenue_point | moneyFormatter }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="approval_status"
                        label="Status"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope">
                            <b-badge pill :variant="getStatusVariant(scope)">
                                {{scope.row.approval_status}}
                            </b-badge>
                        </template>
                    </el-table-column>

                    <el-table-column
                        prop="user.name"
                        label="Member"
                        min-width="150"
                        width="auto"
                    >
                        <template slot-scope="scope" v-if="scope.row.case_recognize">
                            <span class="name">{{ scope.row.case_recognize.user.name }}</span>
                        </template>
                    </el-table-column>
            </el-table>
            <PayoutDetailsModal 
                :showDirectPayoutDetails.sync="modals.showDirectPayoutDetails" 
                :current_comms_payout_summaries="current_view"
                :comms_payout_summaries="comms_payout_summaries"
                @close-modal="modals.showDirectPayoutDetails=false"
                :decide_mode="decide_mode"
                :permission="permission"
            />
        </div>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Table, TableColumn, Select, Option } from 'element-ui'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import PayoutDetailsModal from "@/views/Commission/Hub/HubProfile/CenterProfileDetails/PayoutDetailsModalV2";
export default {
    props:{
        show_table: Boolean,
        hub_id: {
            type: [String, Number]
        },
        hub_team_id: {
            type: [String, Number]
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        PayoutDetailsModal
    },
    computed: {
        ...mapState(useHubStore,['date_picked']),
        show: {
            get() {
                return this.show_table;
            },
            set(newVal) {
                this.$emit('update:show_table', newVal);
            },
        },
    },
    data() {
        return {
            tableData: [],
            sort_by: '',
            modals:{
                showDirectPayoutDetails: false,
            },
            current_view: [],
            decide_mode: false,
            permission: {
                acceptor: false,
                reviewer: false,
                approver: false
            },
            comms_payout_summaries: [],
        }
    },
    watch: {
        async date_picked(newValue) {
            if(newValue)
            {
                const postData = {
                    'hub_id': this.hub_id,
                    'hub_team_id': this.hub_team_id,
                    'start_date': newValue[0],
                    'end_date': newValue[1],
                }

                try {
                    const res = await this.getCommsPayoutSummaryList(postData)
                    this.tableData = res.comms_payout_summaries
                } catch (error) {
                    // Handle any errors that might occur during the API call
                    console.error("Error fetching data:", error);
                }
            }
        },
    },
    async created() {
        const postData = {
            'hub_id': this.hub_id,
            'hub_team_id': this.hub_team_id,
            'start_date': this.date_picked[0],
            'end_date': this.date_picked[1],
        }
        const res = await this.getCommsPayoutSummaryList(postData)
        this.tableData = res.comms_payout_summaries
        this.total = res.total
    },
    methods: {
        ...mapActions(useHubStore,['getCommsPayoutSummaryList']),
        casesSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = 'Total';
                    return;
                } else if (index !== 1 && index !== 4 && index !== 7 && index !== 8) {
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0).toLocaleString(undefined, {maximumFractionDigits: 2});
                    } else {
                        sums[index] = 'N/A';
                    }
                }
            });

            return sums;
        },
        getStatusVariant(scope) {
            if(scope.row)
            {
                const status = scope.row.approval_status;
                if(status == 'Pending')
                {
                    return 'warning';
                }
                else if(status == 'Approved')
                {
                    return 'success';
                }
                else if(status == 'Rejected')
                {
                    return 'danger';
                }
                else if(status == 'Cancel')
                {
                    return 'info';
                }
                else
                {
                    return 'primary';
                }
            }
            return 'warning';
        },
        openView(row) {
            this.modals.showDirectPayoutDetails = true;
            this.current_view = row;
            this.comms_payout_summaries = [row];
        },
    }
}
</script>